class OrderOverview extends HTMLElement {
  constructor() {
    super();
    this.retailerId = this.dataset.retailerId;
    this.ordersBaseEndpoint = `/apps/ax/order-portal/retailers/${this.retailerId}/orders`;
    this.allOrders = [];

    this.initCheckboxDropdowns();
    const initialFilters = this.getFiltersFromUrl();
    this.restoreFilterState(initialFilters);
    const initialPage = parseInt(new URL(window.location.href).searchParams.get('page')) || 1;
    this.fetchOrders(initialFilters, initialPage);
    this.handleActions();
    this.handleFilterAndSort();
  }

  initCheckboxDropdowns() {
    this.querySelectorAll('.op-filter-checkbox-dropdown').forEach(dropdown => {
      const toggle = dropdown.querySelector('.op-filter-dropdown-toggle');
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        this.querySelectorAll('.op-filter-checkbox-dropdown.open').forEach(d => {
          if (d !== dropdown) d.classList.remove('open');
        });
        dropdown.classList.toggle('open');
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.op-filter-checkbox-dropdown')) {
        this.querySelectorAll('.op-filter-checkbox-dropdown.open').forEach(d => d.classList.remove('open'));
      }
    });
  }

  getCheckboxValues(filterId) {
    const container = this.querySelector(`#${filterId}`);
    if (!container) return '';
    const checked = container.querySelectorAll('input[type="checkbox"]:checked');
    return Array.from(checked).map(cb => cb.value).join(',');
  }

  updateDropdownLabel(filterId) {
    const container = this.querySelector(`#${filterId}`);
    if (!container) return;
    const checked = container.querySelectorAll('input[type="checkbox"]:checked');
    const textEl = container.querySelector('.op-filter-dropdown-text');
    if (checked.length === 0) {
      textEl.textContent = container.dataset.placeholder;
    } else {
      const labels = Array.from(checked).map(cb => {
        const label = container.querySelector(`label[for="${cb.id}"]`);
        return label ? label.textContent : cb.value;
      });
      textEl.textContent = labels.join(', ');
    }
  }

  getFiltersFromUrl() {
    const urlParams = new URL(window.location.href).searchParams;
    const params = {};
    if (urlParams.get('status')) params.status = urlParams.get('status');
    if (urlParams.get('type')) params.type = urlParams.get('type');
    if (urlParams.get('query')) params.query = urlParams.get('query');
    return params;
  }

  restoreFilterState(params) {
    if (params.status) {
      const values = params.status.split(',');
      const container = this.querySelector('#status-filter');
      if (container) {
        values.forEach(v => {
          const cb = container.querySelector(`input[value="${v}"]`);
          if (cb) cb.checked = true;
        });
        this.updateDropdownLabel('status-filter');
      }
    }
    if (params.type) {
      const values = params.type.split(',');
      const container = this.querySelector('#type-filter');
      if (container) {
        values.forEach(v => {
          const cb = container.querySelector(`input[value="${v}"]`);
          if (cb) cb.checked = true;
        });
        this.updateDropdownLabel('type-filter');
      }
    }
    const searchInput = this.querySelector('#op-search');
    if (params.query && searchInput) searchInput.value = params.query;
  }

  updateUrlParams(params, page = 1) {
    const url = new URL(window.location.href);
    url.searchParams.delete('status');
    url.searchParams.delete('type');
    url.searchParams.delete('query');
    if (params.status) url.searchParams.set('status', params.status);
    if (params.type) url.searchParams.set('type', params.type);
    if (params.query) url.searchParams.set('query', params.query);
    if (page > 1) {
      url.searchParams.set('page', page);
    } else {
      url.searchParams.delete('page');
    }
    history.replaceState(null, '', url.toString());
  }

  async fetchOrders(params = {}, page = 1) {
    try {
      this.classList.add('op-loading');
      this.hasFilters = !!(params.status || params.type || params.query);

      let url = `${this.ordersBaseEndpoint}?pageNo=${page}`;
      if (params.status) {
        url += `&status=${encodeURIComponent(params.status)}`;
      }
      if (params.type) {
        url += `&type=${encodeURIComponent(params.type)}`;
      }
      if (params.query) {
        url += `&query=${encodeURIComponent(params.query)}`;
      }
      const response = await fetch(url);
      const responseJson = await response.json();

      this.orderPerPage = responseJson.orderPerPage || 40;

      this.allOrders = [];
      this.orders = responseJson.orders || [];
      if (this.hasFilters) {
        this.totalOrders = responseJson.filteredCount || 0;
      } else {
        this.totalOrders = responseJson.totalOrdersCount || 0;
      }
      this.totalPages = Math.ceil(this.totalOrders / this.orderPerPage);
      this.currentPage = responseJson.pageNo || page;

      this.updateUrlParams(params, this.currentPage);
      this.classList.remove('op-loading');
      this.displayCurrentPage();
    } catch (error) {
      console.error('Error fetching orders:', error);
      this.classList.remove('op-loading');
      this.querySelector('#op-orders-table').classList.add('hidden');
      if (document.querySelector('.order-overview')) {
        document.querySelector('order-overview').innerHTML = `<div>${window.theme.strings.opOrderOverview.errorPleaseContactSupport}</div>`;
      }
    }
  }

  goToPage(page) {
    if (page < 1 || page > this.totalPages) return;
    this.fetchOrders(this.collectFilters(), page);
  }

  displayCurrentPage() {
    if (this.orders.length) {
      this.renderOrders();
      this.renderPagination();
      this.querySelector('.op-table').classList.remove('hidden');
    } else {
      this.querySelector('.op-table').classList.add('hidden');
      this.querySelector('.op-pagination').classList.add('hidden');
    }
    if (document.querySelector('#op-table-count')) {
      document.querySelector('#op-table-count').textContent = this.totalOrders;
    }
  }

  renderOrders() {
    let tableData = [];
    // console.log(this.orders);

    this.orders.forEach(order => {
      let statusClass = 'status-color-red';
      switch (order.status) {
        // case 'UNFULFILLED':
        //   statusClass = 'status-color-green'
        //   break;
        // case 'PARTIALLY_FULFILLED':
        //   statusClass = 'status-color-green';
        //   break;
        // case 'FULFILLED':
        //   statusClass = 'status-color-red';
        //   break;
        // case 'PARTIALLY_FULFILLED_LOCKED':
        //   statusClass = 'status-color-yellow';
        //   break;
        // case 'UNFULFILLED_LOCKED':
        //   statusClass = 'status-color-yellow';
        //   break;
        case 'SHIPPED':
          statusClass = 'status-color-red';
          break;
        case 'ORDERING':
          statusClass = 'status-color-green';
          break;
        case 'SHIPPING':
          statusClass = 'status-color-yellow';
          break;
      }
      let orderTypeTexts = [];
      if (order.types && order.types.length) {
        order.types.forEach(type => {
          if (type == 'INVOICE') {
            orderTypeTexts.push(window.theme.strings.opOrderOverview.typeInvoice);
          } else if (type == 'CREDIT_NOTE') {
            orderTypeTexts.push(window.theme.strings.opOrderOverview.typeCreditNote);
          }
        });
      }

      let invoiceNumbers = [];
      if (order.documents && order.documents.length) {
        order.documents.forEach(document => {
          invoiceNumbers.push(document.documentId);
        });
      }

      let moreInfoHtml = '';
      let actionHtml = '';
      if (invoiceNumbers.length) {
        actionHtml = `
          <div class="actions flex gap-3 justify-end items-center">
            ${invoiceNumbers[0].hasFile ? `<a href="/apps/ax/order-portal/retailers/${this.retailerId}/invoices/${invoiceNumbers[0].documentId}/pdf" target="_blank">
              <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.33203 13.2044L1.33203 16.8925C1.33203 17.4514 1.54275 17.9875 1.91782 18.3827C2.29289 18.778 2.8016 19 3.33203 
                  19H15.332C15.8625 19 16.3712 18.778 16.7462 18.3827C17.1213 17.9875 17.332 17.4514 17.332 16.8925V13.2044M9.33315 1V12.9425M9.33315 
                  12.9425L13.9046 8.3793M9.33315 12.9425L4.76172 8.3793" stroke="black" stroke-width="1.5" stroke-linecap="square"></path>
              </svg>
            </a>` : ''}
            ${invoiceNumbers.length > 1 ? `<a href="#" data-action="toggle-line-details">
              <svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="-0.75" x2="14.1626" y2="-0.75" transform="matrix(-0.708126 0.706086 -0.693529 -0.720429 19.168 0)" stroke="#DF2627" stroke-width="1.5"/>
                <line y1="-0.75" x2="14.058" y2="-0.75" transform="matrix(-0.717026 -0.697047 0.684345 -0.729158 11.25 10)" stroke="#DF2627" stroke-width="1.5"/>
              </svg>
            </a>` : ''}
          </div>
        `;
        if (invoiceNumbers.length > 1) {
          moreInfoHtml = `
            <div class="more-data-item invoice-line-data grid grid-flow-col gap-x-6 items-start justify-start">
              ${invoiceNumbers.map(invoiceNumber => `<div class="invoice-line">
                <a href="/pages/faktura-detaljer?id=${invoiceNumber}">${invoiceNumber}</a>
                ${invoiceNumber.hasFile ? `<a href="/apps/ax/order-portal/retailers/${this.retailerId}/invoices/${invoiceNumber.documentId}/pdf" target="_blank">
                    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.33203 13.2044L1.33203 16.8925C1.33203 17.4514 1.54275 17.9875 1.91782 18.3827C2.29289 18.778 2.8016 19 3.33203 
                        19H15.332C15.8625 19 16.3712 18.778 16.7462 18.3827C17.1213 17.9875 17.332 17.4514 17.332 16.8925V13.2044M9.33315 1V12.9425M9.33315 
                        12.9425L13.9046 8.3793M9.33315 12.9425L4.76172 8.3793" stroke="black" stroke-width="1.5" stroke-linecap="square"></path>
                    </svg>
                  </a>` : ''}
                </div>`).join('')}
            </div>
          `;
        }
      }

      let orderIdHtml = '';
      if (order.erpOrderId && order.orderId) {
        orderIdHtml = `<a href="/pages/ordredetaljer?id=${order.orderId}">${order.erpOrderId}</a>`;
      }
      let invoiceListHtml = '';
      if (invoiceNumbers.length == 1) {
        invoiceListHtml = `<a href="/pages/faktura-detaljer?id=${invoiceNumbers[0]}">${invoiceNumbers[0]}</a>`;
      } else {
        invoiceListHtml = `<a href="#" data-action="toggle-line-details" class="invoice-list-text">${invoiceNumbers.join(', ')}</a>`
      }
      tableData.push([
        orderIdHtml,
        invoiceListHtml,
        window.convertDateToDanishFormat(order.shippingDateConfirmed),
        order.campaignDisplayName || '',
        order.customerReferences ? order.customerReferences.join(', ') : '',
        orderTypeTexts.length ? orderTypeTexts.join(', ') : '',
        `<div class="order-status ${statusClass}"></div>`,
        order.currentTotalPriceSet ? parseFloat(order.currentTotalPriceSet).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00',
        actionHtml,
        moreInfoHtml
      ]);
    });
    const table = this.querySelector('#op-orders-table');
    if (table && tableData.length && typeof table.setRows === 'function') {
      table.classList.remove('hidden');
      table.setRows(tableData);
    }
  }
  
  renderPagination() {
    const pagination = this.querySelector('.op-pagination');
    if (!pagination) return;
    if (this.totalPages <= 1) {
      pagination.classList.add('hidden');
      return;
    }
    pagination.classList.remove('hidden');

    const prevPage = this.currentPage - 1;
    const nextPage = this.currentPage + 1;
    let prevHref = new URL(window.location.href);
    prevHref.searchParams.set('page', prevPage);
    let nextHref = new URL(window.location.href);
    nextHref.searchParams.set('page', nextPage);

    pagination.innerHTML = `
      <a href="${prevHref}" class="op-pagination-button prev btn btn--primary" data-page="${prevPage}" ${this.currentPage <= 1 ? 'disabled' : ''}>${window.theme.strings.pagination.previous}</a>
      <span class="op-pagination-current">${this.currentPage} / ${this.totalPages}</span>
      <a href="${nextHref}" class="op-pagination-button next btn btn--primary" data-page="${nextPage}" ${this.currentPage >= this.totalPages ? 'disabled' : ''}>${window.theme.strings.pagination.next}</a>
    `;

    pagination.querySelectorAll('.op-pagination-button').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const page = parseInt(btn.dataset.page);
        if (page < 1 || page > this.totalPages) return;
        this.fetchOrders(this.collectFilters(), page);
      });
    });
  }

  handleActions() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-action="toggle-line-details"]')) {
        event.preventDefault();
        event.target.closest('.op-table-row').classList.toggle('show-more-data');
      }
    });
  }

  collectFilters() {
    const status = this.getCheckboxValues('status-filter');
    const type = this.getCheckboxValues('type-filter');
    const query = this.querySelector('#op-search')?.value || '';
    const params = {};
    if (status) params.status = status;
    if (type) params.type = type;
    if (query) params.query = query;
    return params;
  }

  handleFilterAndSort() {
    this.querySelector('#status-filter')?.addEventListener('change', () => {
      this.updateDropdownLabel('status-filter');
      const params = this.collectFilters();
      this.fetchOrders(params);
    });

    this.querySelector('#type-filter')?.addEventListener('change', () => {
      this.updateDropdownLabel('type-filter');
      const params = this.collectFilters();
      this.fetchOrders(params);
    });

    let opSearchDebounceTimer;
    this.querySelector('#op-search')?.addEventListener('input', () => {
      clearTimeout(opSearchDebounceTimer);
      opSearchDebounceTimer = setTimeout(() => {
        const params = this.collectFilters();
        this.fetchOrders(params);
      }, 500);
    });
  }
}

customElements.define('order-overview', OrderOverview);